import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY } from "@/data/site";

const linkCls = ({ isActive }) =>
  `relative pb-1 text-sm font-semibold transition-colors duration-300 after:absolute after:bottom-0 after:left-0 after:h-0.5 after:bg-[#FF5B00] after:transition-all after:duration-300 ${
    isActive ? "text-white after:w-full" : "text-[#F8FAFC] after:w-0 hover:after:w-full"
  }`;

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-black" data-testid="navbar">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/assets/logo.png" alt="SMS Electrical & Fiber Optic Installers" className="h-16 w-auto" />
        </Link>

        <nav className="hidden items-center gap-10 md:flex" data-testid="nav-desktop">
          <NavLink to="/" end className={linkCls} data-testid="nav-link-home">Home</NavLink>
          <NavLink to="/contact" className={linkCls} data-testid="nav-link-contact">Contact</NavLink>
        </nav>

        <button
          className="text-[#F8FAFC] md:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[#1E293B] bg-black px-4 py-6 md:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-6">
            <NavLink to="/" end className={linkCls} onClick={() => setOpen(false)} data-testid="nav-mobile-link-home">Home</NavLink>
            <NavLink to="/contact" className={linkCls} onClick={() => setOpen(false)} data-testid="nav-mobile-link-contact">Contact</NavLink>
            <a
              href={PHONE_TEL}
              data-testid="nav-mobile-call-button"
              className="flex items-center justify-center gap-2 bg-[#FF5B00] px-5 py-3 font-mono-tech text-xs font-semibold tracking-[0.15em] text-white"
            >
              <Phone className="h-4 w-4" />
              CALL {PHONE_DISPLAY}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
